import { render, staticRenderFns } from "./orderDetailDialog.vue?vue&type=template&id=2009d07c&scoped=true&"
import script from "./orderDetailDialog.vue?vue&type=script&lang=js&"
export * from "./orderDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./orderDetailDialog.vue?vue&type=style&index=0&id=2009d07c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2009d07c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/ctg-code/qihuibao-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VPagination } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog,VIcon,VPagination,VProgressCircular,VTextField})
